<!-- OSS文件管理页面 -->
<template>
  <div style="height: 100%;">
    <el-row :gutter="20" class="container">
      <!-- 右边主要区 -->
      <el-col :span="24" :xs="24" class="container" style="flex-direction: column;border-width: 0;padding-top: 25px;">
        <!-- 路径导航 -->
        <div style="margin-top:0;margin-bottom: 15px;margin-left: 10px;font-weight: bold;">
          <!-- 面包屑组件：动态渲染，保留你原有的箭头分隔符 -->
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item @click.native="navigateTo('/')"> <i class="el-icon-folder-opened"></i> 根目录</el-breadcrumb-item>
            <el-breadcrumb-item v-for="(path, index) in currentPathList" :key="index"
                                @click.native="navigateTo(getPathByIndex(index))">
              <i class="el-icon-folder"></i> {{ path }}
            </el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <!-- 右边头部搜索区 -->
        <el-form :model="queryParams.param" ref="queryForm" :inline="true" label-position="right" v-show="showSearch"
                 label-width="80px">
          <!-- 文件路径 -->
          <el-form-item :label="columnInfo.objectKey.label" prop="objectKey">
            <el-input v-model="queryParams.param.objectKey" placeholder="请输入文件路径" size="small"
                      clearable></el-input>
          </el-form-item>
          <!-- 文件前缀 -->
          <el-form-item label="文件前缀" prop="prefix">
            <el-input v-model="queryParams.param.prefix" placeholder="请输入文件前缀" size="small" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" size="small" @click="handleQuery">搜索</el-button>
            <el-button icon="el-icon-refresh" size="small" @click="resetQuery">重置</el-button>
          </el-form-item>
        </el-form>
        <!-- 右边中部功能区 -->
        <el-row :gutter="10" style="margin-bottom:13px;margin-right: 1px">
          <el-col :span="1.5">
            <el-button
                type="primary"
                plain
                icon="el-icon-upload2"
                size="small"
                @click="handleUpload"
            >上传文件
            </el-button>
          </el-col>
          <el-col :span="1.5">
            <el-button
                plain
                size="small"
                @click="goBack"
                v-if="currentPath !== '/'"
            >返回<i class="el-icon-refresh-left el-icon--right"></i></el-button>
          </el-col>
          <right-toolbar :showSearch.sync="showSearch" @queryTable="handleTableCheck"
                         :columnInfo="columnInfo"></right-toolbar>
        </el-row>
        <!-- 右边中部表格区 -->
        <div class="main">
          <div class="table">
            <!-- Element UI表格组件 -->
            <!-- :data="tableData" - 绑定表格数据，来自Vuex store中的tableData -->
            <!-- @selection-change="handleSelectionChange" - 处理表格行选中事件 -->
            <el-table border ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%;"
                      height="100%"
                      @selection-change="handleSelectionChange" :header-cell-style="{background:'#ECF5FF'}">
              <!-- 复选框列 - 用于批量选择行 -->
              <el-table-column align="center" type="selection" width="55"/>

              <!-- 文件路径列 -->
              <!-- :label="columnInfo.objectKey.label" - 从columnInfo中获取列标题 -->
              <!-- v-if="columnInfo.objectKey.visible" - 根据columnInfo配置决定是否显示该列 -->
              <el-table-column align="center" prop="objectKey" width="399" :label="columnInfo.objectKey.label"
                               v-if="columnInfo.objectKey.visible">
                <template slot-scope="scope">
                  <!-- 如果是目录，显示文件夹图标并支持点击导航 -->
                  <span v-if="scope.row.isDirectory" class="dir-icon" @click="navigateTo(scope.row.objectKey)">
                                        📁 {{ getObjectName(scope.row.objectKey) }}
                                    </span>
                  <!-- 如果是文件，显示文件图标 -->
                  <span v-else class="file-icon">
                                        📄 {{ getObjectName(scope.row.objectKey) }}
                                    </span>
                </template>
              </el-table-column>

              <!-- 文件大小列 -->
              <!-- v-if="columnInfo.size.visible" - 根据columnInfo配置决定是否显示该列 -->
              <el-table-column align="center" prop="size" :label="columnInfo.size.label" v-if="columnInfo.size.visible">
                <template slot-scope="scope">
                  <!-- 仅在非目录时显示文件大小 -->
                  <span v-if="!scope.row.isDirectory">{{ formatFileSize(scope.row.size) }}</span>
                </template>
              </el-table-column>

              <!-- 存储类型列 -->
              <!-- v-if="columnInfo.storageClass.visible" - 根据columnInfo配置决定是否显示该列 -->
              <el-table-column align="center" prop="storageClass" :label="columnInfo.storageClass.label"
                               v-if="columnInfo.storageClass.visible">
                <template slot-scope="scope">
                  <!-- 仅在非目录时显示存储类型 -->
                  <span v-if="!scope.row.isDirectory">{{ scope.row.storageClass }}</span>
                </template>
              </el-table-column>

              <!-- 最后修改时间列 -->
              <!-- v-if="columnInfo.lastModified.visible" - 根据columnInfo配置决定是否显示该列 -->
              <el-table-column align="center" prop="lastModified" :label="columnInfo.lastModified.label"
                               v-if="columnInfo.lastModified.visible">
                <template slot-scope="scope">
                  <!-- 仅在非目录时显示最后修改时间 -->
                  <span v-if="!scope.row.isDirectory">{{ scope.row.lastModified }}</span>
                </template>
              </el-table-column>

              <!-- ETag列 -->
              <!-- v-if="columnInfo.etag.visible" - 根据columnInfo配置决定是否显示该列 -->
              <el-table-column align="center" prop="etag" :label="columnInfo.etag.label" v-if="columnInfo.etag.visible" width="100">
                <template slot-scope="scope">
                  <!-- 仅在非目录时显示ETag -->
                  <span v-if="!scope.row.isDirectory">{{ scope.row.etag }}</span>
                </template>
              </el-table-column>

              <!-- 操作列 -->
              <el-table-column align="center" label="操作" width="290">
                <template slot-scope="scope">
                                    <span v-if="!scope.row.isDirectory">
                                        <el-button @click="handleDownload(scope.row)" type="primary"
                                                   size="mini">下载</el-button>
                                        <el-button @click="handleCopy(scope.row)" type="success"
                                                   size="mini">复制</el-button>
                                        <el-button @click="handleDelete(scope.row)" type="danger"
                                                   size="mini">删除</el-button>
                                        <el-button @click="handlePreview(scope.row)" type="info"
                                                   size="mini">预览</el-button>
                                    </span>
                  <span v-else>
                                        <el-button @click="handleDelete(scope.row)" type="danger"
                                                   size="mini">删除</el-button>
                                    </span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <!-- 右边底部分页区 -->
        <div style="height: 40px;margin-bottom: 0.1rem;">
          <Pagination :totalCount="totalCount" :pageSize="queryParams.limit" :currPage="queryParams.currPage"
                      :pageSizes="pageSizes"
                      :selectList="selectList"
                      @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange"
                      @handleDelAll="handleDelAll" @handleState="handleState"/>
        </div>
      </el-col>
    </el-row>

    <!-- 上传文件对话框 -->
    <el-dialog title="上传文件" :visible.sync="uploadDialogVisible" width="500px">
      <el-form :model="uploadForm" :rules="rules" ref="uploadForm" label-width="80px">
        <el-form-item label="选择文件" prop="file">
          <el-upload
              class="upload-demo"
              ref="upload"
              :auto-upload="false"
              :on-change="(file, fileList) => handleFileChange(fileList)"
              :file-list="fileList"
              accept="*/*"
              :limit="1"
          >
            <el-button slot="trigger" size="small" type="primary">选择文件</el-button>
            <div slot="tip" class="el-upload__tip">请选择要上传的文件</div>
          </el-upload>
        </el-form-item>
        <el-form-item label="文件路径" prop="objectKey">
          <el-input v-model="uploadForm.objectKey" placeholder="例如：/images/test.jpg"
                    :disabled="!fileList.length"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="uploadDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleUploadSubmit">确定上传</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {mapState, mapActions} from 'vuex'
import {Message} from 'element-ui'
import Pagination from '@/components/widget/Pagination'
import RightToolbar from '@/components/widget/RightToolBar'
import {getOssFilePresignedUrl} from '@/api/ossApi'

export default {
  name: 'OssFile',
  components: {
    Pagination,  // 分页组件
    RightToolbar  // 右侧工具栏组件（包含搜索和列控制）
  },
  computed: {
    ...mapState('oss/file', [
      'rules',  // 表单校验规则
      'options',  // 选项数据
      'queryParams',  // 查询参数
      'columnInfo',  // 表格列配置信息
      'dateRange',  // 日期范围
      'tableData',  // 表格数据
      'totalCount',  // 总记录数
      'showSearch',  // 是否显示搜索区域
      'selectList',  // 选中的行数据列表
      'uploadDialogVisible',  // 上传文件对话框可见性
      'uploadForm',  // 上传文件表单数据
      'fileList',  // 上传文件列表
      'currentPath',  // 当前路径
      'currentPathList'  // 当前路径列表（面包屑导航）
    ]),
    // 调试用的计算属性，用于检查表格数据
    debugTableData() {
      console.log('File.vue 中获取到的 tableData:', this.tableData);
      console.log('tableData 长度:', this.tableData.length);
      console.log('其中目录数量:', this.tableData.filter(item => item.isDirectory).length);
      console.log('其中文件数量:', this.tableData.filter(item => !item.isDirectory).length);
      console.log('columnInfo:', this.columnInfo);
      // 检查第一个文件对象的结构
      const firstFile = this.tableData.find(item => !item.isDirectory);
      if (firstFile) {
        console.log('第一个文件对象:', firstFile);
      }
      return this.tableData;
    }
  },
  data() {
    return {
      // 分页大小选项
      pageSizes: [10, 20, 50, 100]  // 可选的每页记录数
    }
  },
  created() {
    // 初始化数据，导航到根目录
    this.navigateTo('/')
  },
  methods: {
    ...mapActions('oss/file', [
      'navigateTo',  // 导航到指定目录
      'goBack',  // 返回上一级目录
      'handleQuery',  // 处理查询请求
      'resetQuery',  // 重置查询参数
      'handleTableCheck',  // 处理表格检查
      'handleSizeChange',  // 处理分页大小变化
      'handleCurrentChange',  // 处理当前页码变化
      'handleSelectionChange',  // 处理行选择变化
      'handleUpload',  // 处理文件上传
      'handleFileChange',  // 处理文件选择变化
      'handleUploadSubmit',  // 处理上传提交
      'handleDownload',  // 处理文件下载
      'handleCopy',  // 处理文件复制
      'handleDelete',  // 处理文件/目录删除
      'handleDeleteBatch',  // 处理批量删除
      'handleDelAll',  // 处理全选删除
      'handleState'  // 处理状态变化
    ]),
    /** 处理选择改变（表格区） */
    handleSelectionChange(selectList) {
      this.selectList = selectList;
    },
    /**
     * 预览文件
     * @param {Object} row - 表格行数据，包含文件的objectKey
     */
    handlePreview(row) {
      // 生成预览URL
      getOssFilePresignedUrl(row.objectKey, {expirationInMinutes: 30}).then(res => {
        if (res.code === 200) {
          window.open(res.data.presignedUrl, '_blank')
        } else {
          Message.error('获取预览URL失败')
        }
      }).catch(err => {
        console.error('获取预览URL失败：', err)
        Message.error('获取预览URL失败')
      })
    },
    /**
     * 格式化文件大小
     * @param {Number|String} bytes - 文件大小，单位为字节
     * @returns {String} 格式化后的文件大小（如：10.24 KB）
     */
    formatFileSize(bytes) {
      if (!bytes) return '0 Bytes'
      // 将字符串转换为数字
      const numBytes = Number(bytes)
      if (isNaN(numBytes)) return '0 Bytes'

      const k = 1024
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB']
      const i = Math.floor(Math.log(numBytes) / Math.log(k))
      return parseFloat((numBytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i]
    },
    /**
     * 根据索引获取路径
     * @param {Number} index - 路径部分的索引
     * @returns {String} 构建的路径字符串
     */
    getPathByIndex(index) {
      const pathParts = this.currentPath.split('/').filter(part => part)
      const newPathParts = pathParts.slice(0, index + 1)
      return '/' + newPathParts.join('/') + '/'
    },
    /**
     * 获取对象名称（去除路径）
     * @param {String} objectKey - 文件或目录的完整路径
     * @returns {String} 仅包含文件名或目录名的字符串
     */
    getObjectName(objectKey) {
      if (objectKey.endsWith('/')) {
        // 目录
        return objectKey.split('/').filter(part => part).pop() || '根目录'
      } else {
        // 文件
        return objectKey.split('/').pop()
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import url('~@/assets/style/index.less');
/* 可在此处添加页面样式 */
.dir-icon {
  font-weight: bold;
  color: #409EFF;
  cursor: pointer;
}

.file-icon {
  color: #606266;
}
</style>